import { Instagram } from "lucide-react";
import { CAFE, IMAGES } from "../data/cafeData";

const TILES = IMAGES.igTiles;

export const InstagramSection = () => (
  <section id="instagram" data-testid="instagram-section" className="bg-[#FDFBF7] py-24 md:py-32">
    <div className="mx-auto max-w-6xl px-5 md:px-8">
      <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="font-accent text-xs font-semibold uppercase tracking-[0.25em] text-[#C86D51]">
            Follow the Journey
          </p>
          <h2 className="mt-4 font-serif text-2xl font-bold tracking-tight text-[#2C1D11] sm:text-3xl lg:text-4xl">
            {CAFE.instagramHandle} on Instagram
          </h2>
          <p className="mt-3 max-w-lg text-base text-[#6E5E53]">
            Daily pours, new specials, and life inside the cafe. Tag{" "}
            <span className="font-accent font-semibold text-[#C86D51]">#NomadCafeYYC</span> to be featured.
          </p>
        </div>
        <a
          href={CAFE.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow-button"
          className="inline-flex items-center gap-2.5 rounded-full bg-[#2C1D11] px-6 py-3 font-accent text-sm font-semibold text-[#FDFBF7] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#3D2817]"
        >
          <Instagram size={16} />
          Follow {CAFE.instagramHandle}
        </a>
      </div>

      <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
        {TILES.map((url, i) => (
          <a
            key={i}
            href={CAFE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`instagram-tile-${i}`}
            className="group relative aspect-square overflow-hidden rounded-3xl"
          >
            <img
              src={url}
              alt={`Nomad Cafe Instagram post ${i + 1}`}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-[#2C1D11]/50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <Instagram size={28} className="text-[#FDFBF7]" />
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);
